const radii = {
  psych: '0 50px',
  psychInverted: '50px 0',
}

export default radii
